class DateUtils {
    static convertToPresentableDate = function (isoDate) {
        return new Intl.DateTimeFormat('en-GB', { year: 'numeric', month: 'long',day: 'numeric', hour: 'numeric', minute: 'numeric' }).format(new Date(isoDate))
    }
}

export default DateUtils;